import { render } from "./AssetWrapper.vue?vue&type=template&id=dca87bba&scoped=true"
import script from "./AssetWrapper.vue?vue&type=script&lang=js"
export * from "./AssetWrapper.vue?vue&type=script&lang=js"

import "./AssetWrapper.vue?vue&type=style&index=0&id=dca87bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca87bba"]])

export default __exports__